import { experiment } from "@faire/web/common/settings/declarations/experiment";

/**
 * Brand PDP Type Update.
 */
export const FE_BRAND_PDP_TYPE_UPDATE_250902 = experiment({
  name: "FE_BRAND_PDP_TYPE_UPDATE_250902",
  identifier: "RetailerToken",
  client: ["RETAILER"],
  notifyAfter: "2025-10-31",
  defaultValue: false,
  productArea: "PRODUCT_PAGE",
});
